import React, { FC, useMemo } from 'react';
import { LiberSaveFrontend } from '@/bo-kit/types';
import { useTranslation } from 'react-i18next';
import { Link, TypographyBody3 } from '@/ui-kit/components';
import liberBlack from '@/ui-kit/theme/colors/liberBlack';
import { TypographyVariant } from '@mui/material';
import { useReturnUrl } from '../hooks/useReturnUrl';
import { getCurrentFrontend } from '@/ui-kit/utils';

export const GoBackLink: FC = () => {
    const { t } = useTranslation('bo-kit__signup');
    const backUrl = useMemo(() => {
        const currentFrontend = getCurrentFrontend();
        return currentFrontend === LiberSaveFrontend.AUTH ? '/' : '/auth';
    }, []);
    const [returnUrl] = useReturnUrl();
    return (
        <TypographyBody3 color='textSecondary'>
            {t('Changed your mind?')}
            &nbsp;
            <Link
                variant={'link4' as TypographyVariant}
                color={liberBlack[200]}
                href={backUrl}
                state={{ returnUrl }}
            >
                {t('Go back')}
            </Link>
        </TypographyBody3>
    );
};
